import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Body2, Title2 } from '@ui/Typography'
import { Button } from '@ui/components/Button'
import { RichIcon } from '@ui/components/RichIcon'
import { EditIcon } from '@ui/icons/Edit.icon'

import { Box } from '@shared/components/Box'

import styles from './EditMode.module.scss'

interface EditModeProps {
  showEditModal: () => void
  showWidgetPalette: () => void
}

export const EditMode: FC<EditModeProps> = ({ showEditModal, showWidgetPalette }) => {
  const { t } = useTranslation()

  return (
    <Box
      maxWidth={1000}
      flex
      flexItem='0 0 auto'
      fullWidth
      align='center'
      gap='x20'
      p='x12'
      bg='surface-white-smoke-0'
      radius='x28'
      className={styles.editModeInfo}
      mx='auto'
    >
      <Box flex align='center' gap='x16' flexItem='1 0 0'>
        <RichIcon
          icon={{ icon: EditIcon, color: 'text-white' }}
          shape='squircle'
          bg='surface-info-p-high-em'
          size='x40'
        />
        <Box flex direction='column'>
          <Title2 medium color='text-purple-high-em'>
            {t('Dashboard.Edit Mode')}
          </Title2>
          <Body2 color='text-med-em'>
            {t(
              'Dashboard.Drag widgets to reorder, resize by dragging corners, or remove with the × button'
            )}
          </Body2>
        </Box>
      </Box>
      <Box flex align='center' gap='x12'>
        <Button.Secondary size='sm' onClick={showEditModal}>
          {t('Dashboard.LayoutSettings')}
        </Button.Secondary>
        <Button.Secondary size='sm' onClick={showWidgetPalette}>
          {t('Dashboard.ManageWidgets')}
        </Button.Secondary>
      </Box>
    </Box>
  )
}
